function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M457.306,182.965c-2.688-4.659-7.698-7.553-13.076-7.553h-70.516v57.311c0.642-0.108,1.299-0.178,1.972-0.178h110.216v0 L457.306,182.965z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M497.957,304.985v-48.736H375.686c-0.673,0-1.33-0.069-1.972-0.178v48.513h-20.741V136.916H20.717v167.668h-2.939 C7.96,304.584,0,312.544,0,322.362c0,9.818,7.96,17.778,17.778,17.778h1.342h35.508c1.049-27.057,23.375-48.749,50.684-48.749 s49.637,21.692,50.684,48.749h198.574h29.577c1.049-27.057,23.375-48.749,50.685-48.749c27.309,0,49.637,21.692,50.684,48.749 h8.705c9.818,0,17.778-7.96,17.778-17.778C512,313.826,505.98,306.701,497.957,304.985z"
})));

var SvgCamion = function SvgCamion(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCamion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/camion.06f67dd4.svg";
export { ForwardRef as ReactComponent };